export function calculateDCF(
  cashFlows: number[],
  wacc: number,
  terminalGrowthRate: number
): number {
  const discountedCashFlows = cashFlows.map((cf, i) => cf / Math.pow(1 + wacc / 100, i + 1));
  const terminalValue = cashFlows[cashFlows.length - 1] * (1 + terminalGrowthRate / 100) / (wacc / 100 - terminalGrowthRate / 100);
  const discountedTerminalValue = terminalValue / Math.pow(1 + wacc / 100, cashFlows.length);
  return discountedCashFlows.reduce((a, b) => a + b, 0) + discountedTerminalValue;
}

export function calculateComparableMetrics(comparables: any[]) {
  const evRevenueMultiples = comparables.map(c => Number(c.evRevenue));
  const evEbitdaMultiples = comparables.map(c => Number(c.evEbitda));

  return {
    medianEvRevenue: calculateMedian(evRevenueMultiples),
    medianEvEbitda: calculateMedian(evEbitdaMultiples),
    meanEvRevenue: calculateMean(evRevenueMultiples),
    meanEvEbitda: calculateMean(evEbitdaMultiples)
  };
}

function calculateMedian(numbers: number[]): number {
  const sorted = numbers.slice().sort((a, b) => a - b);
  const middle = Math.floor(sorted.length / 2);
  return sorted.length % 2 === 0
    ? (sorted[middle - 1] + sorted[middle]) / 2
    : sorted[middle];
}

function calculateMean(numbers: number[]): number {
  return numbers.reduce((a, b) => a + b, 0) / numbers.length;
}